import { KASPI } from '@/config'
import IsAvailableAuthorizeV2 from '@/rules/IsAvailableAuthorizeV2'
import IsAvailableAuthorizeV1 from '@/rules/IsAvailableAuthorizeV1'
import AndRuleSpecification from 'kaspi.frontend/src/modules/ruleSpecification/AndRuleSpecification'
import authApi from '@/api/auth/authApi'
import IsMobileApp from '@/rules/IsMobileApp'

const state = {
  ticket: ''
}

const getters = {
  ticket: state => state.ticket,
  isAuthenticated: state => !!state.ticket
}

const mutations = {
  authSuccess: (state, ticket) => {
    state.ticket = ticket
  },
  authLogout: (state) => {
    state.ticket = ''
  }
}

const actions = {
  authenticate: async function ({ commit }) {
    const response = await authApi.isAuthorized()
    const data = response?.data?.data || {}

    if (typeof data.ticket === 'string' && data.ticket.length > 0) {
      commit('authSuccess', data.ticket)
    }
  },
  authStart: async ({ commit }, { successCallback, product }) => {
    const authData = {
      successCallback: successCallback,
      cancelCallback: KASPI.authCallbacks.authFailureCallback,
      analyticsParams: { product: product },
      analyticsEvents: ['auth-start', 'auth-complete']
    }
    const isAvailableAuthorizeV2 = new AndRuleSpecification(new IsMobileApp(), new IsAvailableAuthorizeV2())
    const isAvailableAuthorizeV1 = new AndRuleSpecification(new IsMobileApp(), new IsAvailableAuthorizeV1())

    if (isAvailableAuthorizeV2.isSatisfiedBy(KASPI.mobapp)) {
      KASPI.mobapp.authorizeV2(JSON.stringify(authData))

      return
    }

    if (isAvailableAuthorizeV1.isSatisfiedBy(KASPI.mobapp)) {
      if (KASPI.mobapp.authorize.length === 2) {
        KASPI.mobapp.authorize(authData.successCallback, product)

        return
      }

      KASPI.mobapp.authorize(authData.successCallback)

      return
    }

    window.location = process.env.VUE_APP_BASE_URL + '/entrance'
  },
  authSuccess: async ({ commit }, ticket) => {
    commit('authSuccess', ticket)

    return Promise.resolve()
  },
  authLogout: ({ commit }) => {
    commit('authLogout')
  },
  authFailure: ({ commit }) => {
    commit('authLogout')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
